import React from "react";
import { ProjectListDto } from "~/api/GeneratedApi";
import { ProjectMapContent } from "./MapTab/ProjectMapContent";
import { ProjectDetailsContent } from "./ProjectDetailsContent";
import { ProjectTabType } from "./ProjectPage";
import { ProjectSubareaContent } from "./ProjectSubareaContent";
import { ProjectUploadContent } from "./UploadTab/ProjectUploadContent";
import { WPRTab } from "./Wpr/WPRTab";

type ProjectTabContentProps = ProjectTabType & ProjectListDto;

export const ProjectTabContent = ({
  activeTab,
  ...props
}: ProjectTabContentProps) => {
  const { id } = props;
  const content = React.useMemo(() => {
    if (!id) return null;
    switch (activeTab) {
      case "details":
        return <ProjectDetailsContent formData={props} />;
      case "map":
        return <ProjectMapContent />;
      case "sub-areas":
        return <ProjectSubareaContent />;
      case "upload-progress":
        return (
          <ProjectUploadContent
            key="uploadProgress"
            uploadFolderType="progress"
            id={id}
            projectData={props}
          />
        );
      case "upload-planning":
        return (
          <ProjectUploadContent
            key="uploadPlan"
            uploadFolderType="plan"
            id={id}
            projectData={props}
          />
        );
      case "wpr":
        return <WPRTab />;

      default:
        return null;
    }
  }, [props, activeTab, id]);
  return content;
};
